import { List } from 'immutable';

export default function mergeSortedLists(
  list1,
  list2,
  valueGetterFn = (x) => x,
  duplicateReconcilerFn
) {
  let mergedList = List();
  let list1Idx = 0;
  let list2Idx = 0;
  let list1OrList2 = null;
  let list1Orlist2Idx = null;

  if (duplicateReconcilerFn) {
    list1OrList2 = duplicateReconcilerFn(list1, list2);
  }

  while (list1Idx < list1.size && list2Idx < list2.size) {
    const list1Value = valueGetterFn(list1.get(list1Idx));
    const list2Value = valueGetterFn(list2.get(list2Idx));

    if (list1Value === list2Value) {
      if (list1OrList2) {
        list1Orlist2Idx =
          list1OrList2 === list1
            ? list1Idx
            : list1OrList2 === list2
            ? list2Idx
            : null;
        mergedList = mergedList.push(list1OrList2.get(list1Orlist2Idx));
        list1Idx++;
        list2Idx++;
      } else {
        mergedList = mergedList.push(list1.get(list1Idx++));
        mergedList = mergedList.push(list2.get(list2Idx++));
      }
    } else if (list1Value < list2Value) {
      mergedList = mergedList.push(list1.get(list1Idx++));
    } else {
      mergedList = mergedList.push(list2.get(list2Idx++));
    }
  }

  while (list1Idx < list1.size) {
    mergedList = mergedList.push(list1.get(list1Idx++));
  }

  while (list2Idx < list2.size) {
    mergedList = mergedList.push(list2.get(list2Idx++));
  }

  return mergedList;
}
